import { WebStorageAdapter } from "./web-storage-adapter";

export const sessionStoreAdapter = new WebStorageAdapter(window.sessionStorage);
